/* Lucky Fish — storefront behaviour: toast, AJAX add-to-cart, cart count. */
(function () {
  var toast = document.getElementById('lf-toast');
  function pop(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(pop._t);
    pop._t = setTimeout(function () { toast.classList.remove('show'); }, 2200);
  }
  window.lfToast = pop;

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
    });
  }

  // Mobile nav (hamburger) toggle
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nav-toggle]');
    if (!t) return;
    var nav = document.querySelector('[data-mobile-nav]');
    if (!nav) return;
    var open = nav.classList.toggle('open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    t.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  });

  // AJAX add-to-cart for any form/button carrying data-add-to-cart.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-add-to-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('disabled', 'disabled');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: Number((form.querySelector('[name="quantity"]') || {}).value || 1) }]
      })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { pop((res.d && res.d.description) || 'Could not add to your catch'); return; }
        pop('Added to your catch 🐟');
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
      })
      .catch(function () { pop('Something went wrong'); })
      .finally(function () { if (btn) btn.removeAttribute('disabled'); });
  });

  // PDP variant price update
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('.pdp select[name="id"]');
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var priceEl = sel.closest('.info').querySelector('[data-price]');
    if (opt && opt.dataset.price && priceEl) priceEl.textContent = opt.dataset.price;
  });

  // PDP thumbnail switcher
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.pdp .thumbs button');
    if (!t) return;
    var main = t.closest('.media').querySelector('.main');
    if (main && t.dataset.img) main.style.backgroundImage = "url('" + t.dataset.img + "')";
    t.parentNode.querySelectorAll('button').forEach(function (b) { b.classList.remove('on'); });
    t.classList.add('on');
  });
})();
